module.exports = __webpack_public_path__ + "media/images/glyphs/edit-note-db788725bd0d9159c4796dea8fd525de.svg";